export default __webpack_public_path__ + "static/media/partner-ignite-tourna.8816d0af.png";